module.exports = __webpack_public_path__ + "img/arrow-right-blue.7a8bc97c.svg";